export const openURLbyTarget = (url, target) => {
    if (target === '_blank') {
        window.open(url);
    }
    else {
        window.location.assign(url);
    }
};
//# sourceMappingURL=openURLbyTarget.js.map